import './index.scss'
$(function () {
    // 20230426
    // let numlist = []
    // let num = $('.download-list li')//.eq(0).height()
    // $.each(num,function(index,item){
    // numlist.push(item.offsetHeight)
    // })
    // let allnum =  Math.max.apply(null, numlist);
    // $('.download-list li').css({'height': allnum+'px'})
    // console.log('鏈€缁堥珮搴?,allnum);


    var s_title = $(".select_box span");
    var s_select = $(".select_box li");

    s_title.click(function (e) {
        $(this).addClass("span_aa");
        $(this).next("ul").slideDown();
        e.stopPropagation();
    });

    s_select.click(function () {
        var s_text = $(this).html();
        var s_title_2 = $(this).parent('ul').prev("span");
        s_title_2.html(s_text).removeClass("span_aa");
        $(this).parent('ul').slideUp();
    });

    $(document).click(function () {
        s_title.removeClass("span_aa");
        $(".select_box ul").slideUp();
    });

});